export const FETCH_GLA_CERTIFICATE_PAYMENT = 'FETCH_GLA_CERTIFICATE_PAYMENT'
export const FETCH_GLA_CERTIFICATE_PAYMENT_SUCCESS = 'FETCH_GLA_CERTIFICATE_PAYMENT_SUCCESS'
export const FETCH_GLA_CERTIFICATE_PAYMENT_FAILURE = 'FETCH_GLA_CERTIFICATE_PAYMENT_FAILURE'
export const FETCH_GLA_CERTIFICATE_PAYMENT_CANCEL = 'FETCH_GLA_CERTIFICATE_PAYMENT_CANCEL'